// README on https://github.com/FortAwesome/vue-fontawesome
// ICONS on https://fontawesome.com/icons

// Fortawesome's official vue component
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { library, config } from '@fortawesome/fontawesome-svg-core'

// Their font awesome lib

/*
  According to webpack's analyzer, using
  import { faCaretDown, faCheck, ..., faUser } from '@fortawesome/fontawesome-free-solid'
  does not reduce vendor package size.
  So we have to import symbols one by one like this
*/
// fontawesome-free-solid

import {
  faArrowLeft,
  faCircleInfo,
  faUserLock,
  faGripLines,
  faFilter,
  faCamera,
  faTrophy,
  faReply,
  faXmark,
  faUserSecret,
  faLocationDot,
  faChevronLeft,
  faChevronRight,
  faBackwardStep,
  faForwardStep,
  faStar,
  faCaretDown,
  faCircle,
  faHelmetSafety,
  faHeadset,
  faCheck,
  faCheckCircle,
  faComment,
  faCommentDots,
  faCompress,
  faDownLeftAndUpRightToCenter,
  faUpRightAndDownLeftFromCenter,
  faEdit,
  faEllipsis,
  faEllipsisH,
  faEllipsisV,
  faExpand,
  faEye,
  faFire,
  faGear,
  faGlobe,
  faHelicopter,
  faLayerGroup,
  faLock,
  faNewspaper,
  faPlusCircle,
  faSearch,
  faShare,
  faSignInAlt,
  faSignOutAlt,
  faSpinner,
  faSquare,
  faTimes,
  faTimesCircle,
  faTrash,
  faUnlock,
  faUser,
  faUserEdit,
  faUserClock,
  faUserPlus,
  faBars,
  faEnvelope,
  faLink,
  faQrcode,
  faRoute,
  faMap,
  faForward,
  faBackward,
  faPlay,
  faPause,
  faMedal,
  faPlus,
  faUsersViewfinder,
  faUserSlash,
  faMinus,
  faUserGroup,
  faChevronDown,
  faUsers,
  faUserCheck,
  faImage,
  faAlignLeft,
  faImages,
  faEarthEurope,
  faShareNodes,
  faMotorcycle,
  faChartSimple,
  faCircleQuestion,
  faMinusCircle,
  faCopy,
  faDownload,
  faAt,
  faCoins,
  faRoad,
  faWrench,
  faArrowRightArrowLeft,
  faPercent,
  faTriangleExclamation,
  faRotateRight,
  faSun,
  faMoon,
  faCloud,
  faCloudRain,
  faCloudSun,
  faVideo,
  faThumbtack,
  faFlag,
  faPaperPlane,
  faCity,
  faGaugeHigh,
  faMountain,
  faLocationCrosshairs,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
  faRuler
} from '@fortawesome/free-solid-svg-icons'

import {
  faStar as faStarRegular,
  faBell,
  faCalendar,
  faCirclePlay,
  faMap as faMapRegular
} from '@fortawesome/free-regular-svg-icons'

import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
  faApple,
  faGoogle
} from '@fortawesome/free-brands-svg-icons'

// import regular from '@fortawesome/fontawesome-free-regular'

// Instead of letting fontawesome include its own css, we do it manually via nuxt.config.js
// to ensure that the file is already included via serverside rendering
config.autoAddCss = false

// Register icon categories (add more using comma)
library.add(
  // Solid
  faArrowLeft,
  faChevronLeft,
  faAt,
  faApple,
  faGoogle,
  faChevronRight,
  faBackwardStep,
  faForwardStep,
  faCaretDown,
  faGripLines,
  faFilter,
  faMinusCircle,
  faCircle,
  faCheck,
  faCheckCircle,
  faLocationDot,
  faComment,
  faTrophy,
  faCommentDots,
  faUserSecret,
  faUsersViewfinder,
  faCamera,
  faCompress,
  faEdit,
  faCopy,
  faDownload,
  faCoins,
  faRoad,
  faEllipsis,
  faEllipsisH,
  faEllipsisV,
  faUserLock,
  faReply,
  faXmark,
  faChartSimple,
  faExpand,
  faHelmetSafety,
  faHeadset,
  faEarthEurope,
  faCircleInfo,
  faEye,
  faFire,
  faGear,
  faGlobe,
  faHelicopter,
  faPlay,
  faPause,
  faDownLeftAndUpRightToCenter,
  faUpRightAndDownLeftFromCenter,
  faImage,
  faImages,
  faUserSlash,
  faLayerGroup,
  faLock,
  faNewspaper,
  faPlusCircle,
  faRoute,
  faForward,
  faBackward,
  faSearch,
  faShare,
  faSignInAlt,
  faSignOutAlt,
  faSpinner,
  faSquare,
  faTimes,
  faTimesCircle,
  faTrash,
  faUnlock,
  faUser,
  faUsers,
  faUserGroup,
  faUserClock,
  faUserEdit,
  faUserPlus,
  faUserCheck,
  faWrench,
  faEnvelope,
  faLink,
  faMap,
  faMedal,
  faShareNodes,
  faMotorcycle,
  faAlignLeft,
  faPlus,
  faStar,
  faMinus,
  faChevronDown,
  faBell,
  faCircleQuestion,
  faEllipsisH,
  faArrowRightArrowLeft,
  faPercent,
  faTriangleExclamation,
  faRotateRight,
  faSun,
  faMoon,
  faCloud,
  faCloudRain,
  faCloudSun,
  faVideo,
  faThumbtack,
  faFlag,
  faPaperPlane,
  faCity,
  faGaugeHigh,
  faMountain,
  faLocationCrosshairs,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
  faRuler,
  // Regular
  faStarRegular,
  faCalendar,
  faCirclePlay,
  faMapRegular,
  // Brands
  faFacebookF,
  faInstagram,
  faYoutube,
  faTwitter,
  faBars,
  faQrcode
)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FontAwesomeIcon', FontAwesomeIcon, {})
  nuxtApp.vueApp.component('FontAwesomeLayers', FontAwesomeLayers, {})
})
